import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PEmptyStateDialogData } from './p-empty-state-dialog-data.interface';
import { PDialogFooterBtnActionType, PDialogFooterBtnConfig } from '../p-dialog-footer-btn-config.interface';

@Component({
    selector: 'p-empty-state-dialog',
    templateUrl: './p-empty-state-dialog.component.html',
    styleUrls: ['./p-empty-state-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PEmptyStateDialogComponent {
    public footerBtnConfig: PDialogFooterBtnConfig[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: PEmptyStateDialogData
    ) {
        this.footerBtnConfig = [
            {
                type: PDialogFooterBtnActionType.Close,
                text: 'Actions.close'
            }
        ];
    }
}
